import { useState } from 'react';
import api from '../api/client';
import Modal from './Modal';

function noticeError(err) {
  return (
    err.response?.data?.detail
    || err.response?.data?.title
    || err.response?.data?.body
    || 'Не удалось показать плашку'
  );
}

/** Жёлтая плашка сразу всем активным ученикам и их родителям. */
export default function BroadcastSiteNoticeButton() {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');
  const [confirmed, setConfirmed] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [ok, setOk] = useState('');
  const [broadcasts, setBroadcasts] = useState([]);
  const [listError, setListError] = useState('');
  const [removingId, setRemovingId] = useState(null);

  function resetForm() {
    setTitle('');
    setBody('');
    setConfirmed(false);
    setError('');
    setOk('');
    setRemovingId(null);
  }

  async function loadBroadcasts() {
    setListError('');
    try {
      const res = await api.get('/messaging/teacher/notices/broadcast/');
      setBroadcasts(Array.isArray(res.data) ? res.data : []);
    } catch {
      setListError('Не удалось загрузить висящие плашки.');
    }
  }

  function openModal() {
    resetForm();
    setBroadcasts([]);
    setOpen(true);
    loadBroadcasts();
  }

  async function handleSend(e) {
    e.preventDefault();
    setBusy(true);
    setError('');
    setOk('');
    try {
      const res = await api.post('/messaging/teacher/notices/broadcast/', {
        title: title.trim(),
        body: body.trim(),
      });
      const students = Number(res.data?.student_count) || 0;
      const parents = Number(res.data?.parent_count) || 0;
      const parentPart = parents > 0 ? ` и ${parents} родителей` : '';
      setOk(`Плашка у ${students} учеников${parentPart}. Каждый закроет её кнопкой «Понятно».`);
      setTitle('');
      setBody('');
      setConfirmed(false);
      await loadBroadcasts();
    } catch (err) {
      setError(noticeError(err));
    } finally {
      setBusy(false);
    }
  }

  async function handleRemove(noticeId) {
    setBusy(true);
    setError('');
    setOk('');
    try {
      await api.delete(`/messaging/teacher/notices/broadcast/${noticeId}/`);
      setRemovingId(null);
      setOk('Плашка снята у тех, кто ещё не нажал «Понятно».');
      await loadBroadcasts();
    } catch (err) {
      setError(noticeError(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <button type="button" className="btn btn-sm btn-outline" onClick={openModal}>
        Плашка всем
      </button>
      <Modal open={open} title="Плашка всем" onClose={() => !busy && setOpen(false)}>
        <form onSubmit={handleSend} className="ops-form">
          <p className="muted" style={{ marginTop: 0 }}>
            Жёлтое объявление сверху на любой странице у всех активных учеников и их родителей.
            Новые ученики, которые появятся позже, эту плашку не увидят.
            Это не письмо и не сообщение в «Сообщениях».
          </p>
          <label className="form-label">
            Заголовок
            <input
              className="form-input"
              type="text"
              required
              maxLength={200}
              placeholder="Каникулы"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </label>
          <label className="form-label">
            Текст
            <textarea
              className="form-input"
              rows={4}
              required
              maxLength={4000}
              placeholder="С 1 по 8 ноября занятий нет."
              value={body}
              onChange={(e) => setBody(e.target.value)}
            />
          </label>
          <label className="form-label" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <input
              type="checkbox"
              checked={confirmed}
              onChange={(e) => setConfirmed(e.target.checked)}
            />
            Показать всем активным ученикам и их родителям
          </label>
          {error && <div className="alert alert-error">{error}</div>}
          {ok && <div className="alert alert-success">{ok}</div>}
          <div className="ops-form-actions">
            <button type="button" className="btn btn-outline" disabled={busy} onClick={() => setOpen(false)}>
              Закрыть
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={busy || !confirmed || !title.trim() || !body.trim()}
            >
              {busy ? 'Отправка…' : 'Показать плашку'}
            </button>
          </div>
        </form>
        <div className="broadcast-notices" style={{ marginTop: '1.25rem' }}>
          <h3 style={{ margin: '0 0 0.5rem', fontSize: '1rem' }}>Сейчас висят</h3>
          {listError && <div className="alert alert-error">{listError}</div>}
          {broadcasts.length === 0 && !listError ? (
            <p className="muted" style={{ margin: 0 }}>Нет плашек, которые кто-то ещё не закрыл.</p>
          ) : (
            <ul className="broadcast-notices-list">
              {broadcasts.map((item) => (
                <li key={item.id} className="broadcast-notices-item">
                  <div>
                    <strong>{item.title}</strong>
                    <p className="muted" style={{ margin: '0.2rem 0 0' }}>
                      Не закрыли: {item.unread_count} из {item.recipient_count}
                    </p>
                  </div>
                  {removingId === item.id ? (
                    <div className="broadcast-notices-confirm">
                      <span>Снять у тех, кто ещё не закрыл?</span>
                      <button
                        type="button"
                        className="btn btn-sm btn-primary"
                        disabled={busy}
                        onClick={() => handleRemove(item.id)}
                      >
                        Снять
                      </button>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline"
                        disabled={busy}
                        onClick={() => setRemovingId(null)}
                      >
                        Нет
                      </button>
                    </div>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-sm btn-outline"
                      disabled={busy}
                      onClick={() => setRemovingId(item.id)}
                    >
                      Снять
                    </button>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      </Modal>
    </>
  );
}
